import { API } from '~/data/api'
import type { UserProfile } from '~/types/user'

export const useSearchService = () => {
  async function searchGroups(query: string, limit?: number, after?: string) {
    const response = await API?.getGroups(query, limit, after)
    return response?.data
  }

  async function searchUsers(query: string) {
    const response = await API?.getUsers(query)
    return response?.data as UserProfile[]
  }

  return {
    searchGroups,
    searchUsers
  }
}
